import React, { useState, useEffect, useRef } from "react";
import RiveComponent from "../Shared/RiveComponent";

export default function PromotionComponent(props) {
    //STATES
    const [countdown, setCountdown] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });
    const [promotionFinished, setPromotionFinished] = useState(false);
    const [promotionText, setPromotionText] = useState('Trajanje promocije: ');
    const [promotionTextDropsAndWins, setPromotionTextDropsAndWins] = useState('Trajanje promocije: ');
    const [superKisaForecast, setSuperKisaForecast] = useState(null);
    const [infoVisible, setInfoVisible] = useState(false);

    // Datumi kao ref — synchronous init iz propsa
    const startDateTimeRef = useRef(new Date(props.startDate));
    const endDateTimeRef = useRef(new Date(props.endDate));
    const currentDateTimeRef = useRef(new Date());
    const countdownTimerRef = useRef(null); 
    let intervalInfoVisible = null;

    useEffect(() => {
        if (currentDateTimeRef.current < startDateTimeRef.current) {
            setPromotionText("Do promocije: ");
            startBannerCountDownTime(startDateTimeRef.current);
        } else {
            startBannerCountDownTime(endDateTimeRef.current);
        }

        if (props.promotion === "super-kisa") {
            casino.repos.casinoSuperkisaForecastRepo.get().then((result) => {
                setSuperKisaForecast(result);
            });
        }

        return cleanUpAll;
    }, []);

    useEffect(() => {
        if (infoVisible) {
            setTimeout(() => setInfoVisible(false), 6000);
        }

        return cleanUpInfoVisible;
    }, [infoVisible])

    function cleanUpAll() {
        cleanUpBannerCountDownTime();
        cleanUpInfoVisible();
    }

    function cleanUpBannerCountDownTime() {
        if (countdownTimerRef.current)
            clearTimeout(countdownTimerRef.current);

        countdownTimerRef.current = null;
    }

    function cleanUpInfoVisible() {
        if (intervalInfoVisible)
            clearTimeout(intervalInfoVisible);

        intervalInfoVisible = null;
    }

    function startBannerCountDownTime(endDateTime) {
        cleanUpBannerCountDownTime();

        // Get todays date and time
        let now = new Date().getTime();
        // Find the distance between now an the count down date
        let distance = endDateTime - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        days = days < 10 ? '0' + days : days;
        let hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
        let minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
        let seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

        setCountdown({ days, hours, minutes, seconds });

        // If the count down is finished, write some text
        if (distance < 0) {
            const currentDate = new Date();

            if (currentDate > new Date(props.startDate) && currentDate < new Date(props.endDate)) {
                setPromotionText("Trajanje promocije: ");
                setPromotionTextDropsAndWins("Trajanje promocije: ");
                startBannerCountDownTime(new Date(props.endDate));
            } else if (currentDate < new Date(props.startDate) && currentDate < new Date(props.endDate)) {
                setPromotionText("Promocija počinje za: ");
                setPromotionTextDropsAndWins("Sljedeći turnir počinje za: ");
                startBannerCountDownTime(new Date(props.startDate));
            } else {
                setPromotionText("Promocija je završila: ");
                setPromotionTextDropsAndWins("Promocija je završila: ");
                setPromotionFinished(true);
            }
        } else {
            countdownTimerRef.current = setTimeout(() => startBannerCountDownTime(endDateTime), 1000);
        }
    }

    return (
        <>
            {props.promotion !== "super-kisa" && props.promotion !== "drops-and-wins" &&
                <div className={"widget-background " + props.promotion}>
                    <div className="top-container" style={!props.amount ? { height: '67%' } : {}}>
                        <div className={"widget-logo " + props.promotion}></div>
                        {props.promotion === "spin-gifts" &&
                            (
                            <div className="widget-rive-logo">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src="https://cdn.supersport.hr/casino/Images/SuperPromocije/spin-gifts/Rive/SpinGifts_animation_title.riv"
                                    stateMachines="State Machine 1"
                                    artboard="Artboard"
                                    useOffscreenRenderer={true}
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ target: ".super-promocije-line", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                />
                            </div>
                            )}
                        {props.promotion === "MultiproviderSuperBomba" &&
                            (
                            <div className="widget-rive-logo MultiproviderSuperBomba">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src="Content/Images/HomePageWidget/MultiproviderSuperBomba/MultiproviderSuperBomba_naslov.riv"
                                    stateMachines="State Machine 1"
                                    artboard="Artboard"
                                    useOffscreenRenderer={true}
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ target: ".super-promocije-line", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                />
                            </div>
                            )}
                    </div>
                    <div className="bottom-container">
                        <div className="counter-container">
                            <p>{promotionText}</p>
                            {!promotionFinished ? (
                                <div className="counter">
                                    <div className="number">
                                        <div className="text-number">{countdown.days}</div>
                                        <div className="text-footer">DANA</div>
                                    </div>
                                    <div className="number">
                                        <div className="text-number">{countdown.hours}</div>
                                        <div className="text-footer">SATI</div>
                                    </div>
                                    <div className="number">
                                        <div className="text-number">{countdown.minutes}</div>
                                        <div className="text-footer">MIN</div>
                                    </div>
                                </div>
                            ) : (<p style={{ color: '#ffffffcc' }}>Započelo {startDateTimeRef.current?.toLocaleDateString('hr-HR', { day: '2-digit', month: 'numeric', year: 'numeric' })} u {startDateTimeRef.current?.toLocaleTimeString('hr-HR', { hour: '2-digit', minute: '2-digit' })}.</p>)}
                        </div>
                        {props.amount > 0 &&
                            <div className="prize-container">
                                <div className="prize-box">Nagrade<br></br> ukupno: </div>
                                <div className="prize-amount">{casino.utils.numberWithCurrencyFromated(props.amount)}</div>
                            </div>}
                        <div className="btns">
                            {props.buttonAction && <div className="promotion-btn-transparent" style={promotionFinished ? { minWidth: '167px' } : {}} onClick={() => window.location = props.buttonAction}>SAZNAJ VIŠE</div>}
                            {!promotionFinished &&
                                <div
                                    className={"promotion-btn " + props.backgroundColor}
                                    style={
                                        props.promotion === "HolidayRushDecember2024" || props.promotion === "EvolutionSuperskokLipanj2025"
                                            ? { minWidth: '167px' }
                                            : {}
                                    }
                                    onClick={() =>
                                        props.promotion === "EvolutionSuperskokLipanj2025"
                                            ? window.location = props.buttonAction
                                            : window.location = props.customLink
                                    }
                                >
                                    <svg className={"fill " + props.backgroundColor} style={{ marginRight: '8%' }} width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z" />
                                    </svg>
                                    ZAIGRAJ
                                </div>
                            }
                        </div>
                    </div>
                    <div className="widget-status">
                        <div className="icons-container">
                            {currentDateTimeRef.current < startDateTimeRef.current && <div className="starts-in"></div>}
                            {currentDateTimeRef.current > startDateTimeRef.current && currentDateTimeRef.current < endDateTimeRef.current && <div className="active"></div>}
                            {currentDateTimeRef.current > endDateTimeRef.current && <div className="finished"></div>}
                            {/*<div className="bonus-type"><p>{props.promotion.DailyBonus ? 'DNEVNI ' : 'POVREMENI '}BONUS</p></div>*/}
                            <div className="info" onClick={() => setInfoVisible(!infoVisible)}></div>
                            <div className="info-msg-container" style={{ display: `${infoVisible ? 'flex' : 'none'}` }}>
                                <div className="info-msg">
                                    Nagradu je potrebno prihvatiti u rubrici Bonusi. Osvojenu nagradu potrebno je u potpunosti odigrati na Casinu.
                                    <br />
                                    <br />
                                    Pravo na Bonus ne ostvaruju igrači kojima je u trenutku isplate bonusa Internet račun zatvoren, izbrisan, ili im je onemogućen pristup istome sukladno pravilima priređivača, te igrači koji su isključeni u Registru isključenih igrača.
                                </div>
                                <div className="info-arrow"></div>
                            </div>
                        </div>
                    </div>
                    {props.promotion !== "WazdanMultidropStage6"
                        && props.promotion !== "XGamesUtrka"
                        && props.promotion !== "EGTDigitalDnevneUtrke"
                        && props.promotion !== "EGTDVikendUtrkaFebruary2026"
                        && props.promotion !== "EvonaVikendUtrka"
                        && props.promotion !== "EndorphinaVikendUtrka"
                        && props.promotion !== "HacksawUtrkaNewMay2026"
                        && props.promotion !== "EGTVikendUtrkaMay2026"
                        && props.promotion !== "EGTDigitalDnevneUtrkeMay2026"
                        && props.promotion !== "AmigoUtrka"
                        && props.promotion !== "ExpanseUtrkeJune2026"
                        && props.promotion !== "EndorphinaDnevneUtrkeJune2026"
                        && props.promotion !== "AmusnetWarmUpTurnir"
                        && props.promotion !== "TangenteUtrkaJune2026"
                        && props.promotion !== "EgtSummerLuckySlots"
                        && props.promotion !== "AmusnetSummerVibes"
                        &&
                        <div className={"rive-container " + props.promotion}>
                            <RiveComponent
                                lazyLoad={true}
                                cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                src={`${casino.config.casinoCDNRiveUrl}/SuperPromocije/${props.promotion}/${props.promotion}-widget.riv`}
                                stateMachines="State Machine 1"
                                artboard="Artboard"
                                useOffscreenRenderer={true}
                                playRequest={true}
                                disablePlayOutsideViewport={{ target: ".super-promocije-line", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                            />
                        </div>
                    }
                    {(props.promotion === "WazdanMultidropStage6"
                        || props.promotion === "XGamesUtrka"
                        || props.promotion === "EGTDigitalDnevneUtrke"
                        || props.promotion === "EGTDVikendUtrkaFebruary2026"
                        || props.promotion === "EvonaVikendUtrka"
                        || props.promotion === "EndorphinaVikendUtrka"
                        || props.promotion === "HacksawUtrkaNewMay2026"
                        || props.promotion === "EGTVikendUtrkaMay2026"
                        || props.promotion === "EGTDigitalDnevneUtrkeMay2026"
                        || props.promotion === "AmigoUtrka"
                        || props.promotion === "ExpanseUtrkeJune2026"
                        || props.promotion === "EndorphinaDnevneUtrkeJune2026"
                        || props.promotion === "AmusnetWarmUpTurnir"
                        || props.promotion === "TangenteUtrkaJune2026"
                        || props.promotion === "EgtSummerLuckySlots"
                        || props.promotion === "AmusnetSummerVibes"
                    )
                        &&
                        <div className={"image-container " + props.promotion}></div>
                    }
                    <div className={"overlay-mask " + props.promotion}></div>
                </div>
            }

            {props.promotion === "super-kisa" &&
                <div className={"widget-background " + props.promotion}>
                    <div className="top-container">
                        <div className={"widget-logo " + props.promotion}></div>
                    </div>
                    <div className="bottom-container">
                        <div className="btns" style={{ height: '100%', minWidth: '167px' }}>
                            <div className={"promotion-btn " + props.backgroundColor} style={{ width: '160px' }}>
                                <svg className={"fill " + props.backgroundColor} style={{ marginRight: '8%' }} width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z" />
                                </svg>
                                SAZNAJ VIŠE
                            </div>
                        </div>
                    </div>
                    <div className="widget-status">
                        <div className="icons-container">
                            {currentDateTimeRef.current < startDateTimeRef.current && <div className="starts-in"></div>}
                            {currentDateTimeRef.current > startDateTimeRef.current && currentDateTimeRef.current < endDateTimeRef.current && <div className="active"></div>}
                            {currentDateTimeRef.current > endDateTimeRef.current && <div className="finished"></div>}
                            {/*<div className="bonus-type"><p>{props.promotion.DailyBonus ? 'DNEVNI ' : 'POVREMENI '}BONUS</p></div>*/}
                        </div>
                    </div>
                    <div className={"rive-container " + props.promotion}>
                        {/*<RiveComponent />*/}
                    </div>
                    <div className={"image-container " + props.promotion}></div>
                    <div className={"overlay-mask " + props.promotion}></div>
                    <div className="forecast-container">
                        <div className="forecast">
                            {superKisaForecast && superKisaForecast.map((item, index) => (
                                <div key={index} className={"forecast-item"}>
                                    <div className="forecast-time">{item.start < 10 ? "0" : ""}{item.start}:00 - {item.end < 10 ? "0" : ""}{item.end}:00</div>
                                    <div className="forecast-weather">
                                        <div className="weather-text">{item.weather}</div>
                                    </div>
                                </div>
                            )
                            )}
                        </div>
                    </div>
                </div>
            }

            {props.promotion === "drops-and-wins" &&
                <div className={"widget-background " + props.promotion}>
                    <div className="top-container" style={{ height: '67%' }}>
                        <div className={"widget-logo " + props.promotion}></div>
                    </div>
                    <div className="bottom-container">
                        <div className="counter-container">
                            <p>{promotionTextDropsAndWins}</p>
                            {!promotionFinished ? (
                                <div className="counter">
                                    <div className="number">
                                        <div className="text-number">{countdown.days}</div>
                                        <div className="text-footer">DANA</div>
                                    </div>
                                    <div className="number">
                                        <div className="text-number">{countdown.hours}</div>
                                        <div className="text-footer">SATI</div>
                                    </div>
                                    <div className="number">
                                        <div className="text-number">{countdown.minutes}</div>
                                        <div className="text-footer">MIN</div>
                                    </div>
                                </div>
                            ) : (<p style={{ color: '#ffffffcc' }}>Započelo {startDateTimeRef.current?.toLocaleDateString('hr-HR', { day: '2-digit', month: 'numeric', year: 'numeric' })} u {startDateTimeRef.current?.toLocaleTimeString('hr-HR', { hour: '2-digit', minute: '2-digit' })}.</p>)}
                        </div>
                        {/*<div className="prize-container">*/}
                        {/*    <div className="prize-box">Nagrade<br></br> ukupno: </div>*/}
                        {/*    <div className="prize-amount">do 2.500x <p>iznosa uloga</p></div>*/}
                        {/*</div>*/}
                        <div className="btns">
                            <div className="promotion-btn-transparent" style={promotionFinished ? { minWidth: '167px' } : {}} onClick={() => window.location = props.buttonAction}>SAZNAJ VIŠE</div>
                            {!promotionFinished &&
                                <div className={"promotion-btn " + props.backgroundColor} onClick={() => window.location = props.customLink}>
                                    <svg className={"fill " + props.backgroundColor} style={{ marginRight: '8%' }} width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z" />
                                    </svg>
                                    ZAIGRAJ
                                </div>
                            }
                        </div>
                    </div>
                    <div className="widget-status">
                        <div className="icons-container">
                            {currentDateTimeRef.current < startDateTimeRef.current && <div className="starts-in"></div>}
                            {currentDateTimeRef.current > startDateTimeRef.current && currentDateTimeRef.current < endDateTimeRef.current && <div className="active"></div>}
                            {currentDateTimeRef.current > endDateTimeRef.current && <div className="finished"></div>}
                            {/*<div className="bonus-type"><p>{props.promotion.DailyBonus ? 'DNEVNI ' : 'POVREMENI '}BONUS</p></div>*/}
                            <div className="info" onClick={() => setInfoVisible(!infoVisible)}></div>
                            <div className="info-msg-container" style={{ display: `${infoVisible ? 'flex' : 'none'}` }}>
                                <div className="info-msg">
                                    Nagradu je potrebno prihvatiti u rubrici Bonusi. Osvojenu nagradu potrebno je u potpunosti odigrati na Casinu.
                                    <br />
                                    <br />
                                    Pravo na Bonus ne ostvaruju igrači kojima je u trenutku isplate bonusa Internet račun zatvoren, izbrisan, ili im je onemogućen pristup istome sukladno pravilima priređivača, te igrači koji su isključeni u Registru isključenih igrača.</div>
                                <div className="info-arrow"></div>
                            </div>
                        </div>
                    </div>
                    <div className={"rive-container " + props.promotion}>
                        <RiveComponent
                            lazyLoad={true}
                            cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                            src={`${casino.config.casinoCDNRiveUrl}/SuperPromocije/${props.promotion}/${props.promotion}-widget.riv`}
                            stateMachines="State Machine 1"
                            artboard="Artboard"
                            useOffscreenRenderer={true}
                            playRequest={true}
                            disablePlayOutsideViewport={{ target: ".super-promocije-line", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                        />
                    </div>
                    {/*<div className={"image-container " + props.promotion}></div>*/}
                    <div className={"overlay-mask " + props.promotion}></div>
                </div>
            }
        </>

    )
}
